// Property Details Section - Email, phone, URLs
import React from 'react';
import { FormSection, EmailFormField, FormField, UrlFormField } from '@/components/common/admin/form';

interface PropertyDetailsSectionProps {
  propertyEmailAddress: string;
  propertyPhoneNumber: string;
  propertyUrl: string;
  propertyFaqUrl: string;
  propertyResidentHandbook: string;
  propertyCbxFilePath: string;
  emailError?: string;
  phoneError?: string;
  urlError?: string;
  onEmailChange: (value: string) => void;
  onPhoneChange: (value: string) => void;
  onUrlChange: (value: string) => void;
  onFaqUrlChange: (value: string) => void;
  onHandbookChange: (value: string) => void;
  onCbxFilePathChange: (value: string) => void;
  disabled?: boolean;
}

export const PropertyDetailsSection: React.FC<PropertyDetailsSectionProps> = ({
  propertyEmailAddress,
  propertyPhoneNumber,
  propertyUrl,
  propertyFaqUrl,
  propertyResidentHandbook,
  propertyCbxFilePath,
  emailError,
  phoneError,
  urlError,
  onEmailChange,
  onPhoneChange,
  onUrlChange,
  onFaqUrlChange,
  onHandbookChange,
  onCbxFilePathChange,
  disabled,
}) => {
  return (
    <FormSection title="Property Details">
      <EmailFormField
        label="Property Email Address"
        value={propertyEmailAddress}
        onChangeText={onEmailChange}
        placeholder="property@example.com"
        error={emailError}
        required
        editable={!disabled}
      />

      <FormField
        label="Property Phone Number"
        value={propertyPhoneNumber}
        onChangeText={onPhoneChange}
        placeholder="(555) 123-4567"
        keyboardType="phone-pad"
        error={phoneError}
        required
        editable={!disabled}
      />

      <UrlFormField
        label="Property Website URL"
        value={propertyUrl}
        onChangeText={onUrlChange}
        placeholder="https://property.com"
        error={urlError}
        required
        editable={!disabled}
      />

      <UrlFormField
        label="Property FAQ URL"
        value={propertyFaqUrl}
        onChangeText={onFaqUrlChange}
        placeholder="https://property.com/faq"
        editable={!disabled}
      />

      <UrlFormField
        label="Resident Handbook URL"
        value={propertyResidentHandbook}
        onChangeText={onHandbookChange}
        placeholder="https://property.com/handbook"
        editable={!disabled}
      />

      <FormField
        label="Resident CBX File Path"
        value={propertyCbxFilePath}
        onChangeText={onCbxFilePathChange}
        placeholder="/path/to/cbx/file"
        autoCapitalize="none"
        editable={!disabled}
      />
    </FormSection>
  );
};

